import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold font-heading mb-4">
              日本伦理<span className="text-accent-300">d3tt</span>
            </h3>
            <p className="text-sm text-background-50/80 leading-relaxed">
              日本伦理d3tt官方资讯平台，为您提供最新最全的相关资讯、背景知识与获取渠道介绍，帮助您全面了解日本伦理d3tt。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-accent-300">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-accent-300">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['日本伦理d3tt资源', '日本伦理d3tt在线', '日本伦理d3tt最新', '日本伦理d3tt合集', '日本伦理d3tt下载', '日本伦理d3tt介绍'].map((tag) => (
                <span
                  key={tag}
                  className="text-xs px-3 py-1 rounded-full bg-background-50/15 text-background-50/80 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 日本伦理d3tt 版权所有 | 本站仅供信息参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}